export default "/assets/website/images/alert.svg?94c0832538e74c1a73f00ca6c391d224";